import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const RedInfoIcon: React.FC<NormalIconProps> = (props) => (
	<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g id="Bold Duotone / Essentional, UI / Danger Circle">
			<path
				id="Vector"
				opacity="0.2"
				d="M58.6666 31.9999C58.6666 17.2723 46.7275 5.33325 31.9999 5.33325C17.2723 5.33325 5.33325 17.2723 5.33325 31.9999C5.33325 46.7275 17.2723 58.6666 31.9999 58.6666C46.7275 58.6666 58.6666 46.7275 58.6666 31.9999Z"
				fill="#F7647C"
			/>
			<g id="Vector_2">
				<path
					d="M31.9999 16.6667C33.1045 16.6667 33.9999 17.5622 33.9999 18.6667V34.6667C33.9999 35.7713 33.1045 36.6667 31.9999 36.6667C30.8953 36.6667 29.9999 35.7713 29.9999 34.6667V18.6667C29.9999 17.5622 30.8953 16.6667 31.9999 16.6667Z"
					fill="#F7647C"
				/>
				<path
					d="M31.9999 45.3334C33.4727 45.3334 34.6666 44.1395 34.6666 42.6667C34.6666 41.194 33.4727 40.0001 31.9999 40.0001C30.5272 40.0001 29.3333 41.194 29.3333 42.6667C29.3333 44.1395 30.5272 45.3334 31.9999 45.3334Z"
					fill="#F7647C"
				/>
			</g>
		</g>
	</svg>
);
